export const environment = {
  production: true,
  ImpataAppAPIRoot: "https://preprodlms.impata.com/",

  //ImpataAppAPIRoot : "https://localhost:44326/",

  userTokenStore: "utkn",
  timezoneapikey: "0d933aa277de4030ae2203539fdf47c4",
  schConfig: "schcfg",
  googleClientId: "781136971353-sq8njd14nkgom1c7jctt9jfioo10a6t0.apps.googleusercontent.com",
  ImpataAppDomainUrl: "https://preprod.impata.com",
  stripePK: "pk_test_51T8zbiD4X1LrQWJEaFjGktBjw0qUtEj40U4GXjIl3IH9Cwfvs7R56fW5ETBufN31dKugblYhBHX3SrebzTeMaMoI00miBq2UsK"
};
